<!-- eslint-disable vue/multi-word-component-names -->
<style>
a {
    cursor: pointer;
}
</style>

<template>
    <header>
        <div class="container">
            <a href="https://www.esunsec.com.tw/" target="_blank"><img class="logo" src="/img/logo.svg" alt="玉山證券" /></a>
            <h1 class="logoTitle d-inline-block" style="font-weight: 600">期貨線上開戶</h1>
        </div>
    </header>
</template>
